export default __webpack_public_path__ + "static/media/project-wizard-csv.cf955a13.png";